import { FC } from 'react';
import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import useCurrentApplicationType from 'features/Onboarding/common/useCurrentApplicationType';
import { throwIfErrorPresent } from 'features/Onboarding/utils';

import PageProps from '../PageProps';
import Component from './component';
import { beneficiariesDocsStatusQuery } from './graphql';
import {
  BeneficiariesDocsStatusQueryData,
  BeneficiariesDocsStatusQueryVariables,
  CompanyLegalBeneficiary,
} from './types';

/**
 * Remove current user, missing emails first
 * @param list
 * @returns
 */
const listBeneficiaries = (
  list?: CompanyLegalBeneficiary[],
): CompanyLegalBeneficiary[] => {
  if (!list) {
    return [];
  }
  return list
    .filter(({ isCurrentUser }) => !isCurrentUser)
    .sort(({ invitation, onboardingStatus }) => {
      if (!invitation?.inviteeEmail) {
        return -1;
      }
      return ['IN_PROGRESS', 'IN_REVIEW'].includes(onboardingStatus) ? 1 : 0;
    });
};

const BeneficiariesDocs: FC<PageProps> = ({ setCurrentPage }) => {
  const { companyProfileId } = useCompanyContext();

  const { applicationType } = useCurrentApplicationType({
    currentPage: 'beneficiaries-docs',
  });
  const { data, error, loading } = useQuery<
    BeneficiariesDocsStatusQueryData,
    BeneficiariesDocsStatusQueryVariables
  >(beneficiariesDocsStatusQuery, {
    skip: !companyProfileId,
    variables: {
      companyProfileId: companyProfileId ?? '',
    },
  });
  throwIfErrorPresent(error);

  const beneficiaries = listBeneficiaries(data?.companyLegalBeneficiaries);

  return (
    <Component
      beneficiaries={beneficiaries}
      companyProfileId={companyProfileId ?? ''}
      hideAddOthersOption={applicationType === 'capital-deposit'}
      loading={loading || applicationType === undefined}
      onGoToHome={() => setCurrentPage('verification-home')}
    />
  );
};

export default BeneficiariesDocs;
